import * as React from "react";
// import { pure } from 'recompose';
import * as Lodash from "lodash";
// import * as Utils from '@Cyclope-Utils/index';
import * as Styled from "@tunnel-components/@sharded/@styled/styled";

/**
 * @function Component : Composant fonctionnel
 * @description : fonction simple qui prend en argument un objet props
 * et rend du contenu sous forme d'élement  JSX
 * @param { ComponentInterface } props
 * @returns { JSX.Element }
 * @implements { ComponentInterface }
 * @type { React.FunctionComponent }
 * @infos "https://reactjs.org"
 */
const Component: React.FunctionComponent<any> = (
  props: ComponentInterface
): JSX.Element => {
  /**
   * @affectation
   * @description :
   * Affectation par décomposition des élements de l'objet (props)
   * les élements existent ou sont créés dans ( ou par) la @class container
   * fonctions , méthodes, variables , objets, tableaux ...., sont les éléments
   * susceptibles de subir une affectation par décomposition
   * exemple : const { elements } = objet ;
   * @infos "https://developer.mozilla.org"
   */
  const {
    item,
    Cart,
    style,
    authorization,
    onInhibitionRemove,
    onPrevious,
    onNext,
    position,
    widthCart,
  } = props;

  /**
   * @expression return()
   * @description :
   * Cette expression transforme un élément JSX en élément HTML
   * @external
   * @name react-custom-scrollbars
   * @infos "https://reactjs.org"
   */

  return (
    <Styled.ContentCarousel style={style}>
      <Styled.NavigationCarousselLeft
        onClick={onPrevious}
        isVisible={!Lodash.isUndefined(position) && position > 0}
      >
        <Styled.BullControl>&larr;</Styled.BullControl>
      </Styled.NavigationCarousselLeft>

      <Styled.ContentCarouselInner>
        {item &&
          item.map((elem: any, index: number) => (
            <Cart
              key={index}
              widthCart={widthCart}
              item={elem}
              authorization={authorization}
              onRemoveInhibition={onInhibitionRemove(elem.id)}
            />
          ))}
      </Styled.ContentCarouselInner>

      <Styled.NavigationCarousselRight onClick={onNext}>
        <Styled.BullControl>&rarr;</Styled.BullControl>
      </Styled.NavigationCarousselRight>
    </Styled.ContentCarousel>
  );
};

/**
 * @interface ComponentInterface
 * @description :
 * Cette interface définit le model du props
 */
interface ComponentInterface {
  item?: any;
  Cart?: any;
  authorization?: any;
  onInhibitionRemove?: any;
  style?: any;
  onPrevious?: any;
  onNext?: any;
  position?: number;
  widthCart?: any;
}
export default React.memo(Component);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@sharded/@widgets/slider/component.tsx